/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PracticeUsersPaginationDto
 */
export interface PracticeUsersPaginationDto {
    /**
     * Current page number
     * @type {number}
     * @memberof PracticeUsersPaginationDto
     */
    page: number;
    /**
     * Number of items per page
     * @type {number}
     * @memberof PracticeUsersPaginationDto
     */
    pageSize: number;
    /**
     * Total number of items
     * @type {number}
     * @memberof PracticeUsersPaginationDto
     */
    total: number;
    /**
     * Total number of pages
     * @type {number}
     * @memberof PracticeUsersPaginationDto
     */
    totalPages: number;
}

/**
 * Check if a given object implements the PracticeUsersPaginationDto interface.
 */
export function instanceOfPracticeUsersPaginationDto(value: object): value is PracticeUsersPaginationDto {
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('pageSize' in value) || value['pageSize'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('totalPages' in value) || value['totalPages'] === undefined) return false;
    return true;
}

export function PracticeUsersPaginationDtoFromJSON(json: any): PracticeUsersPaginationDto {
    return PracticeUsersPaginationDtoFromJSONTyped(json, false);
}

export function PracticeUsersPaginationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PracticeUsersPaginationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'page': json['page'],
        'pageSize': json['pageSize'],
        'total': json['total'],
        'totalPages': json['totalPages'],
    };
}

export function PracticeUsersPaginationDtoToJSON(json: any): PracticeUsersPaginationDto {
    return PracticeUsersPaginationDtoToJSONTyped(json, false);
}

export function PracticeUsersPaginationDtoToJSONTyped(value?: PracticeUsersPaginationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'page': value['page'],
        'pageSize': value['pageSize'],
        'total': value['total'],
        'totalPages': value['totalPages'],
    };
}

